/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contactinformation1Inputs */

const en_contactinformation1 = /** @type {(inputs: Contactinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Information`)
};

const de_contactinformation1 = /** @type {(inputs: Contactinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktinformationen`)
};

/**
* | output |
* | --- |
* | "Contact Information" |
*
* @param {Contactinformation1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contactinformation1 = /** @type {((inputs?: Contactinformation1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contactinformation1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contactinformation1(inputs)
	return de_contactinformation1(inputs)
});
export { contactinformation1 as "contactInformation" }